import { useBranding } from '../contexts/BrandingContext';
import { resolveBrandFavicon, resolveBrandName } from '../constants/brand';
import lmsFavIcon from '../Assets/Images/Logos/favicon.png';

const PLATFORM_ICON = resolveBrandFavicon(lmsFavIcon);

/**
 * The name, icon and subtitle to put in a brand slot — the sidebar header, the
 * auth screens' panel and mobile band — and whether they are still on their way.
 *
 * One rule for every slot: on an institute's page (BrandingContext's
 * `isInstituteContext`) nothing falls back to the platform. A missing logo is
 * `icon: null`, and the slot shows the name's initial; a branding request
 * still in flight is `pending`, and the slot shows an empty placeholder of the
 * same size, so the layout does not jump when the brand arrives.
 *
 * @param {object} [override] { name, favicon, subtitle, pending } — a screen
 *   that must wear a fixed brand: institute registration wears the platform's,
 *   and a student invite opened on our own host wears the inviting institute's.
 *   An override is the WHOLE brand — a missing favicon is no icon, never the
 *   host's, or an institute without a logo would be shown ours.
 */
export default function useBrandMark(override) {
  const b = useBranding();
  if (override) {
    const name = override.name || '';
    return {
      name,
      icon: override.favicon || null,
      subtitle: override.subtitle || '',
      initial: name ? name.trim().charAt(0).toUpperCase() : '',
      pending: Boolean(override.pending),
    };
  }

  const institute = b.isInstituteContext;

  const name = b.brandName || (institute ? '' : resolveBrandName('LMS Campus'));
  const icon = b.faviconUrl || b.logoUrl || (institute ? null : PLATFORM_ICON);
  const subtitle = b.brandSubtitle || (institute ? '' : 'Learning Management System');
  const pending = Boolean(institute && b.loading && !b.brandName);

  return {
    name,
    icon,
    subtitle,
    initial: name ? name.trim().charAt(0).toUpperCase() : '',
    pending,
  };
}
